<template>
  <div>
    <div>
      <div class="col-lg-12">
        <filter-options
          v-bind:pageTitle="pageTitle"
          v-bind:filterItems="filterItems"
          v-on:filter-updated="filterLog"
        />
      </div>

      <div style="margin-top: 8px;">
        <b-table
          responsive
          show-empty
          :empty-text="$t('no_logs_were_found')"
          ref="table"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :current-page="currentPage"
          :per-page="perPage"
          :items="serviceContractsProvider"
          :fields="fields"
          @sort-changed="sortingChanged"
        >
          <template v-slot:table-busy>
            <div style="height: 32px;">
              <div class="mb-3" style="color: #18385f; position: absolute; left: 50%;">
                <b-spinner></b-spinner>
              </div>
            </div>
          </template>

          <template v-slot:cell(logged)="data">{{getDateFormatted(data.value)}}</template>
        </b-table>

        <div class="row" style="text-align: left;">
          <div class="col-sm-6 offset-sm-3">
            <b-pagination
              align="center"
              ref="bottomPagination"
              label-prev-page="first"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              style="margin-top: 10px !important"
            />
          </div>

          <div class="col-sm-3">
            <div class="form-group row" style="margin-top: 10px;">
              <label
                for="inputPassword"
                class="col-sm-7 col-form-label text-right"
              >{{ $t('lines_per_page') }}</label>
              <div class="col-sm-5">
                <b-form-select
                  :options="pageOptions"
                  v-model="perPage"
                  :change="rowsPerPageChange()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { odata } from './../../mixins/odata.js';
import { grid } from './../../mixins/grid.js';
import FilterOptions from '@/components/filter/FilterOptions.vue';
import { bus } from './../../main.js';

export default {
  name: 'LogOverview',
  mixins: [odata, grid],
  components: {
    filterOptions: FilterOptions
  },
  data: function() {
    return {
      filterItems: getFilterDefinition(this),
      pageTitle: 'logs',
      filter: this.getFilter(this, 'lo-filter').filterString,
      isBusy: false,
      sortBy: this.getSortBy(this, 'lo-sortBy', 'logged'),
      sortDesc: this.getSortDesc(this, 'lo-sortDesc', true),
      fields: getTableFields(this),
      totalRows: 0,
      currentPage: this.getCurrentPage(this, 'lo-currentPage', 1),
      perPage: this.getPerPage(this, 'lo-perPage', calculateRowsOnScreen()),
      pageOptions: this.getRowsPerPageOptions(null)
    };
  },
  methods: {
    filterLog(filters) {
      var filterObject = {
        filterString: '',
        items: []
      };

      this.currentPage = 1;
      this.setCurrentPage(this, 'lo-currentPage', 1);

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];
        if (filter.value) {
          var item = {
            id: filter.id,
            value: filter.value
          };

          filterObject.items.push(item);
        }
      }

      this.filter = this.getFilterString(filters);

      filterObject.filterString = this.filter;

      var jsonItems = JSON.stringify(filterObject);

      this.setFilter(this, 'lo-filter', jsonItems);

      var self = this;

      setTimeout(function() {
        self.$refs.table.refresh();
      }, 500);
    },
    sortingChanged(ctx) {
      ctx.currentPage = 1;
      this.setCurrentPage(this, 'lo-currentPage', 1);
    },
    serviceContractsProvider(ctx) {
      var url = this.getServiceUr(
        'logging',
        ctx,
        this.filter,
        this.generateOdataOrderByConditionString(
          ctx.sortBy,
          ctx.sortDesc,
          'dashboard'
        )
      );

      this.setSortBy(this, 'lo-sortBy', ctx.sortBy);
      this.setSortDesc(this, 'lo-sortDesc', ctx.sortDesc);
      this.setCurrentPage(this, 'lo-currentPage', ctx.currentPage);

      let promise = this.$axios.get(url);

      return promise
        .then(data => {
          const items = data.data.value;

          this.totalRows = data.data.count;

          this.currentPage = this.getCurrentPage(this, 'lo-currentPage', 1);

          return items;
        })
        .catch(error => {
          console.log(error);

          return [];
        });
    },
    changeLanguageHandler() {
      this.fields = getTableFields(this);
      this.$refs.table.refresh();
    },
    rowsPerPageChange: function() {
      this.setPerPage(this, 'lo-perPage', this.perPage);
    },
    getDateFormatted: function(date) {
      return date === null || date === ''
        ? ''
        : this.$moment(date).format('DD/MM/YYYY HH:mm:ss');
    }
  },
  created() {
    bus.$on('languageChanged', this.changeLanguageHandler);
  },
  beforeDestroy() {
    bus.$off('languageChanged', this.changeLanguageHandler);
  }
};

function calculateRowsOnScreen() {
  return 10;
}

function getFilterDefinition(context) {
  var filter = context.getFilter(context, 'lo-filter');

  const filterDefinition = [
    { id: 'logged', value: '', type: 'dateRange' },
    { id: 'userName', value: '', type: 'dropdown', page: 'logging' }
  ];

  filter.items.forEach(item => {
    filterDefinition.forEach(filter => {
      if (item.id === filter.id) {
        filter.value = item.value;
      }
    });
  });

  return filterDefinition;
}

function getTableFields(context) {
  return [
    {
      key: 'logged',
      label: context.$t('logged'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'message',
      label: context.$t('message'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    },
    {
      key: 'userName',
      label: context.$t('user'),
      sortable: true,
      thClass: 'tr-left',
      tdClass: 'tr-left'
    }
  ];
}
</script>

<style>
table.b-table > thead > tr > th.sorting:focus {
  outline: none !important;
}
.page-item.active .page-link {
  background-color: #18385f;
  border-color: #18385f;
}
.page-link:focus {
  box-shadow: none;
}
</style>
